import { useState, useEffect } from 'react';
import '../styles/App.css';
import 'leaflet/dist/leaflet.css';
import EasyCrop from '../components/EasyCrop';
import { getCroppedImg } from "../cropUtils";
import { Area } from 'react-easy-crop';
import { DATABASE_URL } from "../config/globals";
import { useNavigate } from "react-router-dom";

type User = {
  displayName: string;
  email?: string;
  [key: string]: any;
};

function UploadImage() {
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupClose, setshowPopupClose] = useState(false);
  const [showMapButton, setShowMapButton] = useState(false);
  const [statusText, setStatusText] = useState("Identifying Fish");
  const [responseUrl, setResponseUrl] = useState<string | undefined>(undefined);
  const [date, setDate] = useState<Date | undefined>(undefined);
  const [user, setUser] = useState<User | null>(null);
  const [newPinId, setNewPinId] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(DATABASE_URL+"/auth/user", { credentials: "include" })
      .then((res) => res.json())
      .then(async (data) => {
        if (data) {
          setUser(data);
        } else {
          setUser(null);
          setShowPopup(true);
          setStatusText("Please log in");
          setshowPopupClose(false);
          await new Promise(resolve => setTimeout(resolve, 2000));
          navigate('/');
        }
      })
      .catch(() => setUser(null));
  }, []);
  
  const handleSendToApi = async (imageUrl: string | undefined, croppedAreaPixels: Area | null, rotation: number | null) => {
    if (!croppedAreaPixels) return;
    if (!imageUrl) return;
    if (!rotation) rotation = 0
    if (!user) {
      setshowPopupClose(true);
      setStatusText("Please log in to upload a photo");
    }
    else {
      const croppedBlob = await getCroppedImg(imageUrl, croppedAreaPixels, rotation);
      const formData = new FormData();
      formData.append("image", croppedBlob, "cropped.jpg");

      setShowPopup(true);
      setStatusText("Uploading Fish");
      setshowPopupClose(false);

      console.log(imageUrl)

      try {
        const response = await fetch(DATABASE_URL+"/api/upload", {
          method: "POST",
          body: formData,
          credentials: "include"
        });


        if (!response.ok) {
          const errorText = await response.text();
          if (response.status == 401) {
            setStatusText("Error: Not logged in")
            setStatusText("HTTP Error: Please try again.");
          }
          else {

          }
          setshowPopupClose(true);
          return;
        }

        const data = await response.json();
        console.log("Uploaded img:", data);
        setResponseUrl(data.imageUrl);
        setNewPinId(data.newPin)
        console.log("SET DATE: "+data.date)
        setDate(data.date)

        setshowPopupClose(false);
        setShowMapButton(true);
        setStatusText("Uploaded Fish! Please pin where you caught it on the map now");
      } catch (err) {
        console.error("Error parsing response:", err);
        setStatusText("HTTP Error: Please try again.");
        setshowPopupClose(true);
      }
    }



  };



  return (
    <div>
      <h1 className="p-10 text-5xl font-bold text-blue-600 text-center">Upload Image</h1>
      <h1 className="text-1xl text-gray-200 text-center">
        Upload an image to FindFish!
      </h1>
      <EasyCrop
        onAction={handleSendToApi}
        actionLabel = "Upload"
      />

      <>
        {/* Overlay */}
        {showPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[101]">
            {/* Popup Box */}
            <div className="bg-gray-900 rounded-2xl shadow-xl p-3 w-80 text-center">
              <h2 className="text-gray-200 text-3xl font-semibold mb-2">Status</h2>
              {!showPopupClose && !showMapButton && (
              <div className="p-4 flex justify-center">
                <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
              )}
              <p className="text-gray-200 mb-4">
                {statusText}
              </p>
              {showPopupClose && (
              <button
                onClick={() => setShowPopup(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                Close
              </button>
              )}
              {showMapButton && (
                <>
                  <img className="p-4" src={responseUrl}></img>
                  <button
                    onClick={() => navigate("/pin_drop", { state: {  newPinId: newPinId, imgUrl: responseUrl, date: date } })}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                  >
                    Go To Map
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </>
    </div>
  );
}

export default UploadImage;
